// initialState.js (or inside reducer file)
export const initialState = {
  toggleMobileVerify: false,
  noOfStep: 3,
  step: 1,
  mobileVerify: {},
  mobileVerifyErrors: {},
};

export const mobileVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
  case "MOBILE_VERIFY_TOGGLE":
      return {
        ...state,
        toggleMobileVerify:
          typeof action.payload === "boolean"
            ? action.payload
            : state.toggleMobileVerify,
      };
    case "MOBILE_VERIFY_SET_STEP":
      return {
        ...state,
        step:
          typeof action.payload === "number"
            ? action.payload
            : state.step,
      };

    case "UPDATE_MOBILE_VERIFY":
      return {
        ...state,
        mobileVerify: {
          ...state.mobileVerify,
          ...action.payload,
        },
      };

    case "SET_ERRORS_MOBILE_VERIFY":
      return {
        ...state,
        mobileVerifyErrors: {
          ...state.mobileVerifyErrors,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
